import { buildUrlFactory } from 'resizin';

import config from 'config/config';

export const build = buildUrlFactory({
    serverUrl: config.imageServer.imageUrl,
    bucket: config.imageServer.alias,
});
